import request from '@aned/request';

// 查询装载率详情
export async function search_day(params) {
  return request('/api/route/loadingRatioTx/search_day/v2', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 查询合计
export async function aggregate(params) {
  return request('/api/route/loadingRatioTx/search_day/aggregate/v2', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

/**
 *
 */

export async function search_week(params) {
  return request('/api/route/loadingRatioTx/search_week', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function weekAggregate(params) {
  return request('/api/route/loadingRatioTx/search_week/aggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function weekExport(params) {
  return request('/api/route/loadingRatioTx/search_week/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function search_month(params) {
  return request('/api/route/loadingRatioTx/search_month', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function monthAggregate(params) {
  return request('/api/route/loadingRatioTx/search_month/aggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function monthExport(params) {
  return request('/api/route/loadingRatioTx/search_month/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 实时装载率
export async function realTime(params) {
  return request('/api/route/loadingRatioTx/real_time', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function search_day_export(params) {
  return request('/api/route/loadingRatioTx/search_day/export/v2', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}